import { isNullOrUndefined } from './isNullOrUndefined';

export function massageToNull<T>(arg: T | null | undefined): T | null {
  if (isNullOrUndefined(arg)) return null;

  return arg;
}
